interface LoaderProps {
  className?: string;
}

const Loader: React.FC<LoaderProps> = ({ className = 'w-25 h-25' }) => (
  <div className={`flex items-center justify-center ${className}`}>
    {/* Light mode: black loader */}
    <img
      src="/loadergif/black-loader.gif"
      alt="Loading..."
      className="block dark:hidden w-full h-full object-contain"
    />
    {/* Dark mode: white loader */}
    <img
      src="/loadergif/white-loader.gif"
      alt="Loading..."
      className="hidden dark:block w-full h-full object-contain"
    />
  </div>
);

export default Loader;
